import { Controller } from "@hotwired/stimulus";
import { handleDropzoneUploadSuccess, initDropzone, initDropzoneBasicEvents } from "../../components/dropzone";

export default class extends Controller {
  static targets = ["dragHint", "previewTemplate"];
  static values = {
    url: String,
    accept: { type: String },
    resetOnSuccess: { type: Boolean, default: false },
  };

  connect() {
    this.dropzone = initDropzone(this.element.id, {}, this._uploadOptions());
    initDropzoneBasicEvents(this.dropzone, this.dragHintTarget, this.element);
    handleDropzoneUploadSuccess(this.dropzone, this.element);

    if (this.resetOnSuccessValue) {
      this.dropzone.on("success", (file) => this.dropzone.removeFile(file));
    }
  }

  _uploadOptions() {
    return {
      url: this.urlValue,
      acceptedFiles: this.acceptValue,
      autoUpload: true,
      clickable: false,
      addRemoveLinks: false,
      previewTemplate: this.previewTemplateTarget.innerHTML,
    };
  }

  disconnect() {
    this.dropzone?.destroy();
  }
}
